import { render } from "./RightSlotUse.vue?vue&type=template&id=c24a39e4"
import script from "./RightSlotUse.vue?vue&type=script&lang=js"
export * from "./RightSlotUse.vue?vue&type=script&lang=js"
script.render = render

export default script